import { visitSource } from "./source";


let inst = null;
let instKey = null;
let wantKey = null;
let wantFunnel = "futmobplus";
const msgSubs = new Set();
const statusSubs = new Set();

const withFunnel = () => {
  if (typeof window === "undefined" || window.__funnelFetch) return;
  const orig = window.fetch.bind(window);
  window.__funnelFetch = true;
  window.fetch = (input, init = {}) => {
    const url = typeof input === "string" ? input : input?.url || "";
    if (!new URL(url, window.location.href).pathname.startsWith("/api/live/")) return orig(input, init);
    const headers = new Headers(init.headers || {});
    headers.set("x-funnel", wantFunnel);
    let body = init.body;
    if (/\/api\/live\/start(\?|$)/.test(url) && typeof body === "string") {
      try { body = JSON.stringify({ ...JSON.parse(body), funil: wantFunnel, ...visitSource() }); } catch { /* ignore */ }
    }
    return orig(input, { ...init, headers, body });
  };
};

export const configureLive = (storageKey, funnel) => {
  wantKey = storageKey || null;
  if (funnel) wantFunnel = funnel;
  withFunnel();
};

const HANDOFF = "lc";
const lsKey = () => wantKey || "futmob_live_chat_v1";

export const sessionHandoff = () => {
  try {
    const raw = localStorage.getItem(lsKey());
    return raw && JSON.parse(raw)?.sid ? btoa(unescape(encodeURIComponent(raw))) : "";
  } catch { return ""; }
};

const adoptHandoff = () => {
  const url = new URL(window.location.href);
  const data = url.searchParams.get(HANDOFF);
  if (!data) return;
  try {
    const st = JSON.parse(decodeURIComponent(escape(atob(data))));
    if (st?.sid && st?.token) localStorage.setItem(lsKey(), JSON.stringify(st));
  } catch { /* ignore */ }
  url.searchParams.delete(HANDOFF);
  window.history.replaceState(null, "", url.pathname + url.search + url.hash);
};

export const getChat = () => {
  if (inst && instKey === wantKey) return inst;
  if (typeof window === "undefined" || !window.LiveChat) return null;
  inst?.stop?.();
  adoptHandoff();
  inst = window.LiveChat.create(wantKey ? { storageKey: wantKey } : {});
  instKey = wantKey;
  inst.onMessages((list) => msgSubs.forEach((f) => f(list)));
  inst.onStatus((s) => statusSubs.forEach((f) => f(s)));
  return inst;
};

export const onLive = (onMsgs, onStatus) => {
  msgSubs.add(onMsgs);
  statusSubs.add(onStatus);
  return () => {
    msgSubs.delete(onMsgs);
    statusSubs.delete(onStatus);
  };
};

export const phoneDigits = (v) => String(v || "").replace(/\D/g, "");
export const isValidPhone = (v) => {
  const d = phoneDigits(v);
  return d.length >= 10 && d.length <= 13;
};

export const msgTime = (at) => {
  const d = at ? new Date(at) : new Date();
  return Number.isNaN(d.getTime()) ? "" : d.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });
};

const PUSH_DISMISS = "fm_push_dismissed";

export const canAskPush = () => {
  try {
    return "Notification" in window && "serviceWorker" in navigator && "PushManager" in window
      && Notification.permission === "default" && !localStorage.getItem(PUSH_DISMISS);
  } catch {
    return false;
  }
};

export const dismissPush = () => {
  try { localStorage.setItem(PUSH_DISMISS, "1"); } catch { /* ignore */ }
};

const urlBase64ToUint8Array = (b64) => {
  const pad = "=".repeat((4 - (b64.length % 4)) % 4);
  const raw = atob((b64 + pad).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

export const enablePush = async (chat, cfg) => {
  const perm = await Notification.requestPermission();
  if (perm !== "granted") return false;
  const reg = await navigator.serviceWorker.register("/sw.js");
  await navigator.serviceWorker.ready;
  const sub = (await reg.pushManager.getSubscription())
    || (await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: urlBase64ToUint8Array(cfg.vapid_public) }));
  await chat.registerPush(sub);
  return true;
};
